import { useNavigate } from 'react-router-dom';
import { NotificationsConsole, type Notification } from '@speles7172/message-console';
import '@speles7172/message-console/styles.css';
import { messageTransport } from '../api/notifications';
import { notificationPath } from '../components/messaging/notificationPath';

/**
 * Everything the bell counts, on a page of its own
 * (COMMUNICATIONS-DESIGN D6).
 *
 * The screen *is* `<NotificationsConsole>` — the rows, the search, the
 * read/unread filter and the pager all come from `@speles7172/message-console`.
 * The same deliberate exception CLAUDE.md records for `AuditLogsPage`: the
 * component rules exist so screens built *here* stay consistent with each
 * other, and this screen is not built here.
 *
 * Wrapped in `.peles-controls` so it wears this application's palette — the
 * bridge from Phase A — rather than the package's default blue.
 */
export function NotificationsPage() {
  const navigate = useNavigate();

  return (
    <div className="p-4 sm:p-6 peles-controls">
      <NotificationsConsole
        transport={messageTransport}
        title="Notifications"
        onOpen={(notification: Notification) => {
          // Where the email's button goes too, so the two cannot disagree. A
          // notification about nothing in particular simply does not navigate.
          const path = notificationPath(notification);
          if (path) navigate(path);
        }}
      />
    </div>
  );
}

export default NotificationsPage;
